import { PLANS } from '@constants/plans'

const {
  FREE_22,
  FREE2LP_22,
  FREE_LIMITED_24,
  LITE_22,
  LITE_LIMITED_24,
  PROFESSIONAL_22,
  PROFESSIONAL_24,
  AGENCY_22,
  PROFESSIONAL_100K_23,
  PROFESSIONAL_200K_23,
  PROFESSIONAL_500K_23,
  PROFESSIONAL_1M_23,
  AGENCY_100K_23,
  AGENCY_200K_23,
  AGENCY_500K_23,
  AGENCY_1M_23,
  CORE_21,
  CREATE_21,
  AUTOMATE_21,
  AGENCY_21,
  ENTERPRISE_25
} = PLANS

const plansSortedByPrice: string[] = [
  FREE_22,
  FREE2LP_22,
  FREE_LIMITED_24,
  LITE_22,
  LITE_LIMITED_24,
  PROFESSIONAL_22,
  PROFESSIONAL_24,
  PROFESSIONAL_100K_23,
  PROFESSIONAL_200K_23,
  PROFESSIONAL_500K_23,
  PROFESSIONAL_1M_23,
  AGENCY_22,
  AGENCY_100K_23,
  AGENCY_200K_23,
  AGENCY_500K_23,
  AGENCY_1M_23,
  ENTERPRISE_25
]

const oldPlansSortedByPrice: string[] = [
  CORE_21,
  CREATE_21,
  AUTOMATE_21,
  AGENCY_21
]

interface PlansProps {
  plan1?: string
  plan2?: string
  isOldPlan?: boolean
}

export const arePlansEqualPrice = ({ plan1, plan2, isOldPlan }: PlansProps) =>
  (isOldPlan ? oldPlansSortedByPrice : plansSortedByPrice).indexOf(
    plan1 as string
  ) ===
  (isOldPlan ? oldPlansSortedByPrice : plansSortedByPrice).indexOf(
    plan2 as string
  )

export const isPlanMoreExpensive = ({ plan1, plan2, isOldPlan }: PlansProps) =>
  (isOldPlan ? oldPlansSortedByPrice : plansSortedByPrice).indexOf(
    plan1 as string
  ) >
  (isOldPlan ? oldPlansSortedByPrice : plansSortedByPrice).indexOf(
    plan2 as string
  )

export const isPlanCheaper = ({ plan1, plan2, isOldPlan }: PlansProps) =>
  (isOldPlan ? oldPlansSortedByPrice : plansSortedByPrice).indexOf(
    plan1 as string
  ) <
  (isOldPlan ? oldPlansSortedByPrice : plansSortedByPrice).indexOf(
    plan2 as string
  )
